import { ActivityView } from "@/components/activity/ActivityView";

/** Platform-wide activity: what every organisation created, and when. The same view sits on client and org pages. */
export function AnalyticsPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] space-y-6 p-8">
      <div>
        <h1 className="text-2xl font-bold">Analytics</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          What organisations across every client have created, and when they were last active.
        </p>
      </div>
      <ActivityView />
    </div>
  );
}
